module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "caldera-config-group"
  }, [_c('div', {
    attrs: {
      "aria-labelledby": "minLogLevelTitle",
      "aria-describedby": "minLogLevelInfo"
    }
  }, [_c('label', {
    attrs: {
      "for": "cf-pro-form-log-level-chooser",
      "id": "minLogLevelTitle"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.strings.minLogLevelTitle) + "\n            ")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "minLogLevelInfo"
    }
  }, [_vm._v(_vm._s(_vm.strings.minLogLevelInfo))])]), _vm._v(" "), _c('div', {
    staticClass: "caldera-config-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.logLevelValue),
      expression: "logLevelValue"
    }],
    attrs: {
      "id": "cf-pro-form-log-level-chooser"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.logLevelValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.logLevels), function(level) {
    return _c('option', {
      directives: [{
        name: "key",
        rawName: "v-key",
        value: (level.number),
        expression: "level.number"
      }],
      domProps: {
        "value": level.number
      }
    }, [_vm._v("\n                    " + _vm._s(level.name) + "\n                ")])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-967240fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/GeneralSettings/logLevel.vue
// module id = 232
// module chunks = 1